import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";

export const Item = styled(Paper)(({theme}) => ({
    backgroundImage: null,
    padding: theme.spacing(1),
    textAlign: 'center',
}));